import {app} from "@/app";
import {get, waitFor} from "@/helpers";
import {AbstractShopifyPageObserver} from "@/services/observer/shopify/pages/AbstractShopifyPageObserver";

export class Cart extends AbstractShopifyPageObserver {
  cartFormSelectors = ['form[action="/cart"]', 'form[action="/checkout"]'];
  cartCheckoutButtonSelectors = ['input[type="submit"]:not([name*="checkout"]):not([name*="update"])', 'input[name="checkout"]', 'button[name="checkout"]', 'input[type="submit"].carthook_checkout', 'button[type="submit"].carthook_checkout'];

  isApplicable(): boolean {
    return (
      app.storage.shopify.page.type === app.storage.shopify.page.types.cart ||
      window.document.querySelectorAll(this.cartFormSelectors.join(",")).length > 0
    );
  }

  async resolve() {
    app.debug('Shopify Event: Page: Cart: started');

    // on page load
    if(
        app.storage.shopify.page.type === app.storage.shopify.page.types.cart &&
        app.storage.shopify.page.source === app.storage.shopify.page.sources.pageUrl
    ) {
      app.debug('Shopify Event: Page: Cart: page loaded');
      await app.storage.shopify.cart.fetchCart().then(() => {
        app.pixel.events.shopify.viewCart.handle();
      });
    }

    // on checkout button click
    const buttonSelectors: string[] = [];
    this.cartFormSelectors.forEach(cartFormSelector => {
      this.cartCheckoutButtonSelectors.forEach(cartCheckoutButtonSelector => {
          buttonSelectors.push(cartFormSelector + " " + cartCheckoutButtonSelector);
      })
    });

    // wait for shopify payment form to load
    await waitFor(() => window.document.querySelectorAll(buttonSelectors.join(",")).length > 0, 500)
      .then(delay => {
        if(delay != 0) {
          app.debug('Shopify Event: Page: Cart: waited for payment form successfully', delay);
        }

        app.debug('Shopify Event: Page: Cart: attaching event to submit button');

        window.document.querySelectorAll(buttonSelectors.join(",")).forEach(submitButton => {
          submitButton.addEventListener("click", function(e) {
            app.debug('Shopify Event: Page: Cart: checkout initiated, loading cart');

            app.storage.shopify.cart.fetchCart().then(() => {
              app.pixel.events.shopify.initiateCheckout.handle();
            });
          }, false);
        })


      })
      .catch((delay) => {
        app.debug('Shopify Event: Page: Cart: waited for payment form unsuccessfully', delay, 'warn');
      });
  }

}
